import classNames from 'classnames';
import {useState} from 'react';
import { focusNumber } from '@/utils/dom';
import { IAnswerItem } from '@/utils/ctype';
import style from './index.module.less';

interface IProp {
  min: number; 
  max: number;
  answerAll: Array<IAnswerItem| undefined| null>;
  currentFocus: number;
  setPanelHandle: (val: number) =>void; 
  index: number;
  pageDataIndex: number; 
  setFocusIndexHandle: (val: number) =>void;
  isActive: boolean;
}

export default function QuestionIndicator(props: IProp) {
  const {min, max, answerAll, currentFocus, setPanelHandle, index, pageDataIndex, setFocusIndexHandle} = props;
  const {isActive} = props;

  const focusQuestion = (number: number) => {
    setFocusIndexHandle(number);
    focusNumber(number, min);
  };

  const createIndicator = () => {
    const arr = [];
    for (let i = min; i <= max; i++) {
      arr.push(
        <div key={i} className={classNames(style.numberBox, style.itemBox, (answerAll[i - 1] === null || (answerAll[i - 1] && answerAll[i - 1]!.answer[0])) ? style.active : null)} >
          <div className={classNames(style.number, currentFocus === i ? style.active : '')} onClick={() => focusQuestion(i)}>{i}</div>
        </div>
      );
    }
    return arr;
  };

  const clickHandle = () => {
    setPanelHandle(index);
    focusQuestion(min);
    
  };
  return (
    <div className={style.box}>
      {/*  isActive ? style.active : '' */}
      <div className={classNames(style.itemBox)} onClick={clickHandle}>
        <div className={style.button}>Part {index + 1}</div>
      </div>
      {
        pageDataIndex === index ? createIndicator()
          :<div className={classNames(style.numberBox, style.itemBox, style.answerCount)}>
            <span className={style.count}>{min}</span>
            <span className={style.of}> of </span>
            <span className={style.count}>{max}</span>
          </div>
      }
    </div>
    
  );
}